import { getAnalytics, logEvent } from "firebase/analytics";

/**
 * Function Click Analytics Event
 */
export function logAnalyticsEvent(eventName, event) {
  const analytics = getAnalytics();
  return logEvent(analytics, eventName, event);
}
